export interface ClientPrincipal {
  identityProvider?: string;
  userId?: string;
  userDetails?: string; // usually email/UPN
  userRoles?: string[];
  claims?: Array<{ typ: string; val: string }>;
  name?: string; // convenience – from claims.name when available
}

export async function getClientPrincipal(): Promise<ClientPrincipal | null> {
  try {
    const res = await fetch('/.auth/me', { credentials: 'include' });
    if (!res.ok) return null;
    const data = await res.json().catch(() => null);
    const principal: ClientPrincipal | null = data?.clientPrincipal ?? null;
    if (!principal) return null;

    // Attempt to derive display name from claims
    if (principal.claims && !principal.name) {
      const nameClaim = principal.claims.find(c => c.typ?.toLowerCase().includes('name'));
      if (nameClaim?.val) principal.name = nameClaim.val;
    }
    return principal;
  } catch {
    return null;
  }
}

